import { NotFoundPage } from "./components/404/404.component";
import { PerfilComponent } from "./components/perfil/perfil.component";
import { InicioComponent } from "./components/inicio/inicio.component";
import { TramitesComponent } from "./components/tramites/tramites.component";
import { InstructionsComponent } from "./components/instructions/instructions.component";
import { NavbarComponent } from "./components/navbar/navbar.component";
import { TopMenuComponent } from "./components/menu/top-menu/topmenu.component";
import { routing, appRoutingProviders } from "./app.routing";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { AppComponent } from "./app.component";
import { HomeComponent } from "./components/home/home.component";
import { MenuComponent } from "./components/menu/menu.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
//migracion import { HttpModule } from '@angular/http';
import { ClaveUnicaComponent } from "src/app/components/claveunica/claveunica.component";
import { ClaveUnicaTokenComponent } from "src/app/components/claveunica/token/claveunica_token.component";
import { TabsComponent } from "./components/formulario/tabs/tabs.component";
import { FileUploadModule } from "ng2-file-upload";
import { EscapeHtmlPipe } from "./pipes/keep-html.pipe";
import { MainNavComponent } from "./components/main-nav/main-nav.component";
//migracion import { BorradoresComponent } from './components/borradores/borradores.component';
import { NgxPaginationModule } from "ngx-pagination";
import { CommonModule } from "@angular/common";
import { Ng9RutModule } from "ng9-rut";
import { HttpClientModule } from "@angular/common/http";

//ArcWizard
import { ArchwizardModule } from "angular-archwizard";
import { NavbarModule } from "./components/navbar/navbar.module";
import { RegistroComponent } from "./components/home/registro/registro.component";

import { ToastrModule } from "ngx-toastr";
//Angular material
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

// import {
//   MatAutocompleteModule,
//   MatBadgeModule,
//   MatBottomSheetModule,
//   MatButtonModule,
//   MatButtonToggleModule,
//   MatCardModule,
//   MatCheckboxModule,
//   MatChipsModule,
//   MatDatepickerModule,
//   MatDialogModule,
//   MatDividerModule,
//   MatExpansionModule,
//   MatGridListModule,
//   MatIconModule,
//   MatInputModule,
//   MatListModule,
//   MatMenuModule,
//   MatNativeDateModule,
//   MatPaginatorModule,
//   MatProgressBarModule,
//   MatProgressSpinnerModule,
//   MatRadioModule,
//   MatRippleModule,
//   MatSelectModule,
//   MatSidenavModule,
//   MatSliderModule,
//   MatSlideToggleModule,

//   MatSnackBarModule,
//   MatSortModule,
//   MatStepperModule,
//   MatTableModule,
//   MatTabsModule,
//   MatToolbarModule,
//   MatTooltipModule,
//   MatTreeModule,
//   MAT_DATE_LOCALE,
// } from '@angular/material';

import { OptionFormComponent } from "./components/option-form/option-form.component";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { AppEffects } from "./app.effects";
import { formReducer } from "./reducers/forms.reducer";
import { notificationReducer } from "./reducers/notification.recuder";

import { FilterPipe2 } from "./pipes/filter.pipe2";
import { NgxSpinnerModule } from "ngx-spinner";

import { TakePhotoComponent } from "./components/perfil/takePhoto/takePhoto.component";
import { CertificadosComponent } from "./components/certificados/certificados.component";
import { SolicitudesExpComponent } from "src/app/components/solicitudesexp/solicitudesexp.component";

import { Navbar_certComponent } from "./components/certificados/navbar_cert/navbar_cert.component";
import { Navbar_certModule } from "./components/certificados/navbar_cert/navbar_cert.module";
import { LottieAnimationViewModule } from "ng-lottie";
import { SidenavService } from "./services/sidenav.service";
import { BorradorStorageService } from "./services/borrador-storage.service";
//migracionimport { crearBorradorComponent } from './components/borradores/crearBorrador/crearBorrador.component';
import { NgxdModule } from "@ngxd/core";
import { ItemsComponent } from "./components/items/items.component";

//SEGUIMIENTO EXPEDIENTE
import { Seguimiento_expedienteComponent } from "./components/seguimiento_expediente/seguimiento_expediente.component";
import { Acta_expedienteComponent } from "./components/seguimiento_expediente/acta_expediente/acta_expediente.component";
import { Nl2BrPipeModule } from "nl2br-pipe";
import { OrderByPipe } from "./pipes/order-by.pipe";
import { PresentacionComponent } from "./components/presentacion/presentacion.component";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { finalFormReducer } from "./reducers/form_final.reducer";
import { ForgotPassComponent } from "./components/home/forgot-pass/forgot-pass.component";
import { MesonOnlineComponent } from "./components/meson-online/meson-online.component";

// SEGUIMIENTO DE CERTIFICADOS
import { Seguimiento_certificadoComponent } from './components/seguimiento_certificado/seguimiento_certificado.component';
import { Busqueda_dirComponent } from './components/totem/busqueda_dir/busqueda_dir.component';

import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import {
  MatNativeDateModule,
  MatRippleModule,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatBadgeModule } from "@angular/material/badge";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSliderModule } from "@angular/material/slider";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSortModule } from "@angular/material/sort";
import {
  MatHeaderCellDef,
  MatHeaderRowDef,
  MatTableModule,
} from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatStepperModule } from "@angular/material/stepper";

import { MatTreeModule } from "@angular/material/tree";
import { HttpModule } from "@angular/http";
import { IngresoBnupComponent } from "./components/bnup/ingreso-bnup/ingreso-bnup.component";
import { MatFormFieldModule } from "@angular/material/form-field";

import { SeguimientoExpedienteComponent } from './components/seguimiento-expediente/seguimiento-expediente.component';
import { ActaExpedienteComponent } from './components/acta-expediente/acta-expediente.component';

//google maps
import { AgmCoreModule } from '@agm/core';

@NgModule({
  declarations: [
    ForgotPassComponent,
    ItemsComponent,
    EscapeHtmlPipe,
    OrderByPipe,
    AppComponent,
    HomeComponent,
    MenuComponent,
    TopMenuComponent,
    //  TramitesComponent,
    ClaveUnicaComponent,
    ClaveUnicaTokenComponent,
    //mIGRACION  TabsComponent,
    NavbarComponent,
    //migracion  CertificadosComponent,
    InstructionsComponent,
    MainNavComponent,
    //migracion BorradoresComponent,
    OptionFormComponent,
    RegistroComponent,
    InicioComponent,
    FilterPipe2,
    PerfilComponent,
    TakePhotoComponent,
    //migracion    AuxUrlComponent,
    // AuxUrlcertComponent,
    SolicitudesExpComponent,
    //migracion Navbar_certComponent,
    //migracion   NotFoundPage,
    //borrador  crearBorradorComponent,
    Seguimiento_expedienteComponent,
    Acta_expedienteComponent,
    PresentacionComponent,
    //migracion AuxUrlInfTerComponent,
    MesonOnlineComponent,
    // Seguimiento_certificadoComponent,
    Busqueda_dirComponent,
    // SeguimientoCertificadosComponent,
    // SeguimientoExpedienteComponent,
    // Acta3ExpedienteComponent
  ],
  imports: [
    BrowserModule,
    Ng9RutModule,
    NgxPaginationModule,
    Nl2BrPipeModule,
    routing,
    HttpClientModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    FileUploadModule,
    ArchwizardModule,
    CommonModule,
    NavbarModule,
    Navbar_certModule,
    BrowserAnimationsModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatStepperModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatTableModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    NgxSpinnerModule,
    HttpClientModule,
    HttpModule,
    LottieAnimationViewModule.forRoot(),
    StoreModule.forRoot({
      form: formReducer,
      contador: notificationReducer,
      formFinal: finalFormReducer,
    }),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
    }),
    EffectsModule.forRoot([AppEffects]),
    ToastrModule.forRoot(),
    NgxdModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDFh2Wj0FCzyw9JFW7ksCR8xQ6mbPkM_24'
    })
  ],
  entryComponents: [
    AppComponent,
    HomeComponent,
    MenuComponent,
    //  TramitesComponent,
    TopMenuComponent,
    ClaveUnicaComponent,
    ClaveUnicaTokenComponent,
    InstructionsComponent,
    //MIGRACION  TabsComponent,
    MainNavComponent,

    //migracion   BorradoresComponent,
    OptionFormComponent,
    RegistroComponent,
    InicioComponent,
    PerfilComponent,
    TakePhotoComponent,
    //migracion  AuxUrlComponent,
    //  AuxUrlcertComponent,
    CertificadosComponent,
    SolicitudesExpComponent,
    Navbar_certComponent,
    //migracion  NotFoundPage,
    //  crearBorradorComponent,
    Seguimiento_expedienteComponent,
    Acta_expedienteComponent,
    //migracion   AuxUrlInfTerComponent,
    MesonOnlineComponent,
    Seguimiento_certificadoComponent
    //migracion   Solicitud_certificadosComponent
  ],
  providers: [
    appRoutingProviders,
    { provide: MAT_DATE_LOCALE, useValue: "es-ES" },
    SidenavService,
    BorradorStorageService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
